<template>
<div>
  <v-dialog 
    persistent
    v-model="showDialog" 
    max-width="500px"
    scrollable>
    <v-card>
      <v-card-text style="width: 500px">
        <v-container grid-list-xs>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field 
                name="password" 
                label="Días de validez"
                type="number" 
                :min="1"
                v-model="validateDays"
                v-on:keyup.enter="changePassword"
                ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-data-table
                single-select
                :headers="headers"
                :items="datesList"
                hide-actions
                class="elevation-1"
                loading="true"
                v-bind:pagination.sync="pagination"
                :key="fu"
              >
                <template v-slot:items="props">
                  <tr  @click="rowClick(props.item)" :style="{'background-color': props.item.priceChangeDate === itemSelected.priceChangeDate ? 'gray': 'white', 'cursor': props.item.current ? 'auto' : 'pointer' }" style="">
                  <td v-if="props.item.current">Actual</td>
                  <td v-else>{{ props.item.priceChangeDate | formatDateTime }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog">Cancelar</v-btn>
          <v-btn color="blue darken-1" flat @click="updateUser" :disabled="itemSelected.priceChangeDate === undefined" >Aceptar</v-btn>
      </v-card-actions>
    </v-card>    
  </v-dialog>
</div>
</template>

<script>
import { getPriceChangeDates } from '../../services/priceHistory';

import moment from 'moment';
import FileSaver from 'file-saver';

export default {
  props: {
    user: {
      type: Object,
      default: undefined,
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pagination: {sortBy: 'column1', descending: true, rowsPerPage: -1},
      validateDays: 1,
      headers: [
        {
          text: 'Fecha',
          align: 'left',
          sortable: true,
          value: 'priceChangeDate',
        }
      ],
      datesList: [],
      fu: 0,
      itemSelected: {}
    };
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog-price');
    },
    async updateUser(){
      console.log(this.user, this.validateDays);
      const parameters = {
        priceChangeDate: this.itemSelected.priceChangeDate,
        userId: this.user.id,
        validDays: this.validateDays
      };
      try {
        const result = await this.axios.post("/catalogs/product/linkuser", parameters);
        console.log(result);
        if(result.data.statusCode === 200){
          this.$emit('update-user', {priceChangeDate: parameters.priceChangeDate});
        }else{
          this.closeDialog()
          this.$emit('error', result.data.friendlyMessage[0]);
        }
      } catch (error) {
        
        this.closeDialog()
        this.$emit('error', error);
      } finally {
        this.itemSelected = {};
      }


    },
    rowClick(item){
      if(item.current){
        return
      }
      if(item.priceChangeDate === this.itemSelected.priceChangeDate){
      this.itemSelected = {}
      }else{
      this.itemSelected = item
      }
      this.fu ++;
    }
  },
  async mounted() {
    try {
      const datesResults = await getPriceChangeDates();
      this.datesList = datesResults.data;
      this.datesList.unshift({ priceChangeDate: new Date(), current: true });
    } catch (error) {
      this.$emit('error', error.message);
    }
  }
};
</script>
